import React from 'react';

function AboutText(props) {
    return (
        <div className="about-text-section">
            <div className="about-text-section-wrapper bg-black text-center">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-10 offset-lg-1">
                            <div className="about-text-section-inner">
                                <h2 className="heading heading-large light-1">
                                    {props.content}
                                </h2>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default AboutText;

// Duplicate for About page only
export function AboutTextAboutPage() {
    return (
        <div className="about-text-section">
            <div className="about-text-section-wrapper bg-black text-center">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-10 offset-lg-1">
                            <div className="about-text-section-inner">
                                <h2 className="heading heading-large light-1">About Us</h2>
                                <p className="paragraph light-1 mt-3">This is a dummy about section for the About page. You can edit this text independently without affecting the About section on the home page. Add your own content here to describe your organization, mission, or any other information relevant to your About page.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
